/**
 * EmptyState — shown when no sessions match the date range (CR-0015).
 */
import { Calendar } from "lucide-react";
import { todayIso, daysAgoIso } from "@/utils/fmtTime";

export default function EmptyState({ onTryWeek }) {
  return (
    <div
      data-testid="report-empty-state"
      className="mx-4 mt-6 bg-white rounded-md shadow-sm border px-6 py-10 flex flex-col items-center text-center"
      style={{ borderColor: "#E5E7EB" }}
    >
      <Calendar size={48} style={{ color: "#9CA3AF" }} />
      <div className="text-lg font-bold mt-4" style={{ color: "#111827" }}>
        No data for this range
      </div>
      <div className="text-sm mt-2 max-w-md" style={{ color: "#6B7280" }}>
        Try widening the date range or check that breakfast sessions ran on
        these dates.
      </div>
      <button
        data-testid="empty-try-week"
        onClick={() => onTryWeek(daysAgoIso(6), todayIso())}
        className="mt-5 rounded-md px-4 py-2 text-sm font-semibold text-white"
        style={{ backgroundColor: "#22C55E" }}
      >
        Try last 7 days
      </button>
    </div>
  );
}
